'use client';

import { useSelector } from 'react-redux';

import { projectSliceSelectors } from '@highlight-cp/redux-state';

/**
 * @description
 * Hook to get the current project ID from the Redux store.
 * @returns The current project ID or null if no project is selected.
 * @example
 * ```tsx
 * const projectId = useGetCurrentProjectId();
 * ```
 */
export const useGetCurrentProjectId = () => {
  return useSelector(projectSliceSelectors.id);
};
